// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".got-question[data-v-3d26cab2]{margin-top:.3em;display:inline-block}#level-cta a[data-v-3d26cab2]:hover{background:none;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
